import { useTranslation } from 'react-i18next';
import styles from './FooterLinks.module.scss';
import type { FC } from 'react';
import React from 'react';
import { TextV2 } from 'components/TextV2/TextV2';
import { useFiMerchant } from 'hooks/useFiMerchant';

export const FooterLinks: FC = () => {
  const { t } = useTranslation();
  const { subscriberRefId } = useFiMerchant();
  const year = new Date().getFullYear();

  const termsUrl = t('footer.links.terms');
  const privacyPolicyUrl = t('footer.links.privacy-policy');

  const queryParamToAdd = `?subscriberRefId=${subscriberRefId}`;

  const onClick = (event: React.MouseEvent<HTMLElement>, url: string) => {
    if (subscriberRefId) {
      event.preventDefault();
      /* WebViews don't natively support <a target='_blank'> or window.open(href, '_blank')
       * Mobiliti app for FI Integration currently only supports window.open(href, '_blank')
       */
      window.open(url + queryParamToAdd, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <footer className={styles.footerWrapper}>
      <div className={styles.links}>
        <ul>
          <li>
            <TextV2
              href={termsUrl}
              tagName="a"
              variant="small"
              value={t('terms')}
              onClick={event => onClick(event, termsUrl)}
            />
          </li>
          <li>
            <span>&#8226;</span>
          </li>
          <li>
            <TextV2
              href={privacyPolicyUrl}
              tagName="a"
              variant="small"
              value={t('privacy-policy')}
              onClick={event => onClick(event, privacyPolicyUrl)}
            />
          </li>
          <li>
            <span>&#8226;</span>
          </li>
          <li>
            <TextV2 tagName="p" variant="small" value={t('footer.copyright', { year })} />
          </li>
        </ul>
      </div>
    </footer>
  );
};
